export default function env(
  state = {},
  action // eslint-disable-line no-unused-vars
) {
  return state;
}



// WEBPACK FOOTER //
// ./js/reducers/config.js